<section [attr.aria-label]="isOnAnalysis ? 'Similarity analyses in-depth' : 'Similarity analyses summary'">
<article class="matching_sources" [ngClass]="isOnAnalysis ? 'isOnAnalysis' : ''">
  <ng-container *ngIf="!isOnAnalysis; else onAnalysis">
    <header>
      <section class="header-section">
        <section class="header-label">
          <img src="../../../../../../assets/report_v2/similarity_analyses.svg" alt="">
          <section>
            <h2 tabindex="-1" #sectionHeading>{{ 'new_entries.similarity_analyses' | translate }}</h2>
            <span>{{
              'new_entries.similarity_percentage' | translate }}</span>
          </section>
        </section>
        <div class="matching-responsive">
          <button (click)="toggleIsOnAnalysis()" aria-label="Go to details of language analysis">
            <span>{{ 'metadata.go_to_details' | translate }}</span>
            <img src="../../../../../../assets/report_v2/arrow-right.svg"
              alt="">
          </button>
        </div>
      </section>
    </header>
  </ng-container>
  <ng-template #onAnalysis>
    <header>
      <section class="header-section">
        <section class="header-label">
          <img src="../../../../../../assets/report_v2/similarity_analyses.svg" alt="">
          <section>
            <h2 tabindex="-1" #sectionHeading>{{ 'new_entries.similarity_analyses' | translate }}</h2>
            <span>{{
              'new_entries.similarity_percentage' | translate }}</span>
          </section>
        </section>
        <button (click)="toggleIsOnAnalysis()" aria-label="Back to Summary Analysis">
          <img src="../../../../../../assets/report_v2/arrow-right.svg" alt="">
        </button>
      </section>
    </header>
    <!-- <header>
       <section class="header-section isOnAnalysis">
         <button (click)="toggleIsOnAnalysis()" tabindex="0">
           <img src="../../../../../../assets/report_v2/arrow-right.svg" alt="Arrow right. Click to go to the language analysis">
         </button>
         <section class="header-label" tabindex="0" aria-label="Similarity Analyses">
           <img src="../../../../../../assets/report_v2/doc-search.svg" alt="Language Analysis ">
           <h3>Similarity analyses</h3>
         </section>
       </section>
       <span tabindex="0" aria-label="Percentage shows similarity to existing sources">Percentage shows similarity to existing sources</span>
     </header> -->
  </ng-template>
  <app-language-bar [allSources]="allSources" [canEdit]="canEdit" [isOnAnalysis]="isOnAnalysis"
    [similarityAnalysis]="similarityAnalysis"></app-language-bar>
</article>
</section>